<template>
  <div class="advertise-container" v-show="showAdvertise">
    <z-swipe :autoplay="swipeDelay">
      <z-swipe-item v-for="(el, idx) in swipeList" :key="el.id" :zz-sortid="idx" :zz-sortname="`banner-${idx}`" @click="() => goToUrl(el.jumpUrl,el.id)">
        <div class="swiper-container">
          <z-image :src="el.picUrl" class="swiper-img" fit="fill"/>
        </div>
      </z-swipe-item>
    </z-swipe>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Swipe, SwipeItem, Image } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'

export default {
  name: 'AdverTise',
  props: {
    advertise: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    showAdvertise() {
      return this.advertise.switchFlag === '1'
    },
    swipeDelay() {
      return this.advertise.delay || 3000
    },
    swipeList() {
      return this.advertise.advertiseDetails || []
    }
  },
  methods: {
    goToUrl(url, id) {
      lego.send({
        pagetype: 'ZZUP_NEWHELPCENTER',
        actiontype: 'NEWHELPCENTER_ADVERTISE_CLICK',
        backup: {
          advertiseId: id
        }
      })
      native.skipToUrl({
        targetUrl: url
      })
    }
  },
  components: {
    zSwipe: Swipe,
    zSwipeItem: SwipeItem,
    zImage: Image
  }
}

</script>
<style scoped lang="less">
  @import './index.less';
</style>